import React from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";

interface MinicartHeaderProps {
  item_count: number;
  settings: {
    show_minicart_title?: boolean;
    title_text?: string;
    title_text_style?: string;
    show_cart_item_count?: boolean;
    item_count_text_style?: string;
    close_icon?: string;
    background_color?: string;
    direction?: string;
    border_radius?: string;
    margin_bottom?: number;
    padding?: number;
    border?: string;
  };

  onClose: () => void;
}

export const MinicartHeader = ({ item_count = 0, settings = {}, onClose}: MinicartHeaderProps) => {
  const {
    show_minicart_title = true,
    title_text = "Cart",
    title_text_style = "h5",
    show_cart_item_count = true,
    item_count_text_style = "font-normal",
    close_icon = "icon-x-thin",
    background_color = "#ffffff",
    direction = "row",
    border_radius = "6px",
    margin_bottom = 0,
    padding = 10,
    border = "1px solid #e5e7eb"
  } = settings;

  const containerStyle = {
    backgroundColor: background_color,
    borderRadius: border_radius,
    marginBottom: `0px`,
    padding: `0px`,
    display: "flex",
    flexDirection: direction,
    justifyContent: direction === "row" ? "space-between" : "flex-start",
    alignItems: direction === "row" ? "center" : "flex-start",
    gap: direction === "column" ? "10px" : "0",
    border
  };

  return (
    <div 
      className="minicart-header " 
      style={containerStyle}
    >
      {show_minicart_title && (
      <div className="minicart-header__title mb-1 lg:mb-0 flex items-center gap-2 flex w-full">
    
            <div className={`flex w-full justify-between`}>
                <div className={`flex justify-center items-center gap-[16px]`}> 
                    <div className={title_text_style}>{title_text}</div>
                    {show_cart_item_count && (
                        <span className={`cart-item-count ${item_count_text_style}`}>
                        <span className="cart-item-count__value" data-cart-item-count>    {item_count} {item_count === 1 ? 'item' : 'items'}
                        </span>
                        </span>
                    )}
                        
                </div>
               <button className={`icon text-[24px] ${close_icon}`} aria-hidden="true" onClick={onClose}></button>
            </div>
        </div>
      )}
    </div>
  );
};